import type { TravelMeta } from "../types/travelDetail";

type TravelMetaSource = {
  basic: {
    durationLabel: string;
  };
  sections: {
    overview?: {
      meta?: TravelMeta[];
    };
  };
};

export const buildHeroMetaItems = (data: TravelMetaSource): TravelMeta[] => {
  const durationValue = data.basic.durationLabel.trim();
  const metaItems = data.sections.overview?.meta ?? [];
  const durationItem = metaItems.find(
    (item) => (item.value || "").trim() === durationValue
  );
  const customItems = metaItems
    .filter((item) => {
      const label = (item.label || "").trim();
      const value = (item.value || "").trim();
      return Boolean(label || value) && value !== durationValue;
    })
    .slice(-2);

  return [
    {
      label: durationItem?.label?.trim() || "Duration",
      value: data.basic.durationLabel
    },
    ...customItems
  ];
};
